import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { createContext, useState, useCallback, useMemo } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var OverlayContext = /*#__PURE__*/createContext(null);

if (process.env.NODE_ENV !== 'production') {
  OverlayContext.displayName = 'OverlayContext';
}

function OverlayProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(new Map()),
      _useState2 = _slicedToArray(_useState, 2),
      overlayById = _useState2[0],
      setOverlayById = _useState2[1];

  var mount = useCallback(function (id, element) {
    setOverlayById(function (overlayById) {
      var cloned = new Map(overlayById);
      cloned.set(id, element);
      return cloned;
    });
  }, []);
  var unmount = useCallback(function (id) {
    setOverlayById(function (overlayById) {
      var cloned = new Map(overlayById);
      cloned["delete"](id);
      return cloned;
    });
  }, []);
  var context = useMemo(function () {
    return {
      mount: mount,
      unmount: unmount
    };
  }, [mount, unmount]);
  return /*#__PURE__*/jsxs(OverlayContext.Provider, {
    value: context,
    children: [children, _toConsumableArray(overlayById.entries()).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          id = _ref3[0],
          element = _ref3[1];

      return /*#__PURE__*/jsx(React.Fragment, {
        children: element
      }, id);
    })]
  });
}

export { OverlayContext, OverlayProvider };
